import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BASE_URL, BillStatus, CustRelationChoice, isEmpty, isFeatureAllowed, NODATA, OfferType, PayMedium, printDebugLog, SUCCESS, UiButtonAction } from "../../constants/Constants";
import { BANQUET_BUFFET_TYPE, BANQUET_DECORATION, BANQUET_DJ, BANQUET_FUNCTION, BANQUET_SHIFT } from "../../constants/ConfigConstant";
import { Autocomplete, Box, Chip, Grid, Paper, Stack, TextField } from "@mui/material";
import { BookingCalendar } from "../global/js/BookingCalendar";
import useAuth from "../../hooks/useAuth";
import SnpComponent from "../../global/SnpComponent";
import {
    deleteCustomerFromBill,
    fetchBanquetBillPayAuditInformation, fetchBanquetBillPayInformation,
    fetchBanquetForBill,
    fetchComboFoodDetails,
    fetchSingleCustomerData, getBanquetInformation, getBillData, handleDeleteEntireBill, handleDeleteUnpaidDetails, handleOnClickRoom,
    handleSubmitBill,
    showAvailableRooms
} from "./networkController";
import { BanquetForm } from "./BanquetForm";
import { PaymentScreen } from "./PaymentScreen";
import { RoomForm } from "./RoomForm";
import { fetchConfig } from "../global/commonNetworkController";
import { ExtraBanquetForm } from "./ExtraBanquetForm";
import { BuffetForm } from "./BuffetForm";
import { CustomerDetailsForm } from "./CustomerDetailsForm";
import { normalizeCustomer, SINGLE_CUST_FORM } from "../../constants/pojoservice";
import { getTime } from "../../constants/DateUtils";
import { CANCEL_BILL_MANAGEMENT, EPAYBILLING } from "../../constants/Permissions";

const CreateBanquetBill = () => {

    const DATE_SELECTION = 1;
    const CUSTOMER = 2;
    const ROOM_SELECTION = 3;
    const BANQUET = 4;
    const BUFFET = 5;
    const EXTRA_DETAILS = 6;

    const BANQUET_BILL_CATEGORIES = [
        { id: DATE_SELECTION, name: "Date Selection Form" },
        { id: CUSTOMER, name: "Customer Form" },
        { id: BANQUET, name: "Banquet Form" },
        { id: ROOM_SELECTION, name: "Room Selection Form" },
        { id: BUFFET, name: "Buffet Form" },
        { id: EXTRA_DETAILS, name: "Extra Details Form" },
    ];

    const INITIAL_SNP_COMPONENT = {
        showDialog: false,
        outSideClickDismiss: true,
        title: "",
        subTitle: "",
        negativeAction: "",
        positiveAction: "",
        positiveReq: false,
        isLoader: false,
        iconReq: false,
        iconContent: "",
        snackBarOpen: false,
        snackBarMsg: "",
        cancelExtra: false,
        negativeReq: false,
        requestType: 0,
        handleSnpSubmit: null,
        handleSnpCancel: null,
    };

    const COMMON_INITIAL_INFORMATION = {
        added: false,
        totalSize: 0,
        items: [],
    };

    // const INITIAL_EXTRA_ORDER = {
    //     header: "",
    //     itemName: "",
    //     quantity: 0,
    //     price: 0.0,
    //     totalPrice: 0.0,
    // }

    const location = useLocation();
    const navigate = useNavigate();
    const { activeShopHash, authUser, isInvoiceAllowed, prefixBillName, isRoleAllowed } = useAuth();
    const [snpComponent, setSnpComponent] = useState(INITIAL_SNP_COMPONENT);
    const [selectedCategory, setSelectedCategory] = useState({ id: 1, name: "Date Selection Form" });

    const [banquetInformation, setBanquetInformation] = useState({});
    const [billInformation, setBillInformation] = useState({});

    const [totalBanquetBookingDetails, setTotalBanquetBookingDetails] = useState(COMMON_INITIAL_INFORMATION);
    const [totalHotelRoomDetails, setTotalHotelRoomDetails] = useState(COMMON_INITIAL_INFORMATION);
    const [totalBuffetDetails, setTotalBuffetDetails] = useState(COMMON_INITIAL_INFORMATION);
    const [customerInformation, setCustomerInformation] = useState(COMMON_INITIAL_INFORMATION);
    const [singleCustData, setSingleCustData] = useState(SINGLE_CUST_FORM);
    const [keyMapInformation, setKeyMapInformation] = useState(new Map());

    const [extrasOrderMap, setExtraOrderMap] = useState(new Map());
    const [billPayInfo, setBillPayInfo] = useState({});
    const [billPayAudit, setBillPayAudit] = useState({});
    const [duesAmt, setDuesAmt] = useState(0.0);

    const [configBanquetShift, setConfigBanquetShift] = useState([]);
    const [configBanquetFunction, setConfigBanquetFunction] = useState([]);
    const [configBuffetType, setConfigBuffetType] = useState([]);
    const [configDecoration, setConfigDecoration] = useState(new Map());
    const [configDj, setConfigDj] = useState(new Map());

    const [roomData, setRoomData] = useState([]);
    const [listBanquetHall, setListBanquetHall] = useState([]);
    const [comboList, setComboList] = useState([]);

    const [bookings, setBookings] = useState([]);
    const [sameDateBookingCount, setSameDayBookingCount] = useState({});
    const [snpLoader, setSnpLoader] = useState(false);

    const [mainRoomId, setMainRoomId] = useState("");

    const globalNetworkLock = useRef(false);

    const [spocAdded, setSpocAdded] = useState(true);


    const clearAllDetails = () => {
        printDebugLog("clearAllDetails");
        setTotalBanquetBookingDetails(COMMON_INITIAL_INFORMATION);
        setTotalHotelRoomDetails(COMMON_INITIAL_INFORMATION);
        setTotalBuffetDetails(COMMON_INITIAL_INFORMATION);
        setExtraOrderMap(new Map());
        setBillPayInfo({
            gstAllowed: true,
            takenDenom: OfferType.No_Offer,
            takenOffrAmt: 0,
            payMedium: PayMedium.NOT_SELECTED,
            cgst: 9,
            sgst: 9,
        });
        setBillPayAudit({});
    }

    const handleFetchBooking = (fieldId) => {
        printDebugLog("handleFetchBooking", fieldId);
        fetchBillData(fieldId);
        fetchBillPayData(fieldId);
    }

    useEffect(() => {
        printDebugLog("CreateBanquetBill useEffect", location.state);
        const fieldId = location?.state?.id;
        const viaBill = location?.state?.via_bill;
        if (!isEmpty(fieldId) && !isEmpty(viaBill)) {
            if (viaBill === 0) {
                setMainRoomId(fieldId);
                fetchBanquetInformation(fieldId);
                fetchBookingInCalendarView(fieldId);
            } else {
                handleFetchBooking(fieldId);
            }
        }
        fethBillConfig(BANQUET_SHIFT);
        fethBillConfig(BANQUET_FUNCTION);
        fethBillConfig(BANQUET_BUFFET_TYPE);
        fethBillConfig(BANQUET_DECORATION);
        fethBillConfig(BANQUET_DJ);
    }, [location.state]);

    useEffect(() => {
        if (billPayInfo) {
            const dAmt = Number(billPayInfo?.finalPrice ?? 0) - Number(billPayInfo?.paidAmount ?? 0);
            setDuesAmt(dAmt);
        }
    }, [billPayInfo])

    useEffect(() => {
        printDebugLog("CreateBanquetBill billInformation", billInformation?.checkInDate, billInformation?.checkOutDate, globalNetworkLock.current);
        if (!isEmpty(billInformation?.checkInDate)
            && !isEmpty(billInformation?.checkOutDate)) {
            // if (!globalNetworkLock.current) {
            //     clearAllDetails(); Removed because its clearing the data in sync
            // }
            fetchOtherBanquetInfo();
            fetchRoomData(billInformation?.checkInDate, billInformation?.checkOutDate);
        }
    }, [billInformation?.checkInDate, billInformation?.checkOutDate]);

    const fethBillConfig = async (pConfigName) => {
        await fetchConfig({
            authUser: authUser,
            activeShopHash: activeShopHash,
            configName: pConfigName,
            onResponseCallback: (configName, value) => {
                if (configName === BANQUET_SHIFT) {
                    if (value) {
                        setConfigBanquetShift(value);
                    }
                } else if (configName === BANQUET_FUNCTION) {
                    if (value) {
                        setConfigBanquetFunction(value);
                    }
                } else if (configName === BANQUET_BUFFET_TYPE) {
                    if (value) {
                        setConfigBuffetType(value);
                    }
                } else if (configName === BANQUET_DECORATION) {
                    if (value) {
                        setConfigDecoration(new Map(Object.entries(value)));
                    }
                } else if (configName === BANQUET_DJ) {
                    if (value) {
                        setConfigDj(new Map(Object.entries(value)));
                    }
                }
            }
        })
    }

    const fetchBanquetInformation = async (roomId) => {
        await getBanquetInformation({
            authUser: authUser,
            activeShopHash: activeShopHash,
            mRoomId: roomId,
            setSnpLoader: setSnpLoader,
            onResponseCallback: (payload) => {
                setBanquetInformation(prev => ({
                    ...prev, ...payload,
                }));
                const isMultiple = payload.multiple || false;
                const roomBooked = payload.roomBooked || false;
                if (!isMultiple && roomBooked) {
                    const biilId = payload.billId || "";
                    handleFetchBooking(biilId);
                } else {
                    setBillPayInfo(prev => ({
                        ...prev,
                        gstAllowed: true,
                        takenDenom: OfferType.No_Offer,
                        takenOffrAmt: 0,
                        payMedium: PayMedium.NOT_SELECTED,
                        cgst: 9,
                        sgst: 9,
                    }))
                }

            }
        })
    };

    const fetchBookingInCalendarView = async (roomId) => {
        await handleOnClickRoom({
            authUser: authUser,
            activeShopHash: activeShopHash,
            id: roomId,
            setSameDayBookingCount: setSameDayBookingCount,
            setBookings: setBookings,
        })
    }

    const fetchRoomData = async (checkInDate, checkOutDate) => {
        await showAvailableRooms({
            authUser: authUser,
            activeShopHash: activeShopHash,
            checkInDate: `${checkInDate} ${getTime()}`,
            checkOutDate: `${checkOutDate} ${getTime()}`,
            mDate: false,
            setLoader: setSnpLoader,
            onResponseCallback: (payload) => {
                setRoomData(payload.data);
            }
        })
    };

    const deepConvertObjToMap = (obj) => {
        const map = new Map();
        for (const [key, value] of Object.entries(obj)) {
            const innerMap = new Map();
            for (const [iKey, iValue] of Object.entries(value)) {
                innerMap.set(iKey, iValue);
            }
            map.set(key, innerMap);
        }
        return map;
    };

    const convertObjToMap = (obj) => {
        const map = new Map();
        for (const [key, value] of Object.entries(obj)) {
            map.set(key, value && typeof value === "object" && !Array.isArray(value)
                ? convertObjToMap(value)
                : value
            );
        }
        return map;
    };

    const fetchBillData = async (billId) => {
        globalNetworkLock.current = true;
        await getBillData({
            authUser: authUser,
            activeShopHash: activeShopHash,
            myParam: billId,
            onResponseCallback: (payload, error) => {
                if (payload === null) {
                    console.warn("getBillData", "payload is null", error)
                    return;
                }
                setBillInformation(prev => ({
                    ...prev,
                    ...payload
                }));
                if ((payload?.billStatus ?? BillStatus.INUI) === BillStatus.CANCELLED_BILL) {
                    setSnpComponent(prev => ({
                        ...prev,
                        isLoader: false,
                        negativeReq: true,
                        negativeAction: "Home",
                        positiveAction: "Dismiss",
                        positiveReq: true,
                        showDialog: true,
                        outSideClickDismiss: false,
                        cancelExtra: true,
                        subTitle: `This bill is cancelled`,
                        handleSnpCancel: () => navigate("/home"),
                        handleSnpSubmit: () => setSnpComponent(INITIAL_SNP_COMPONENT),
                    }));
                }
                const custSize = Number(payload.listCustomerDetailsSize ?? 0);
                setCustomerInformation((prev) => {
                    const updatedItems = payload.listCustomerDetails.map((item, index) => ({
                        ...item,
                        index: index + 1, // add key "index" starting from 1
                    }));

                    return {
                        ...prev,
                        added: custSize > 0,
                        items: updatedItems,
                        totalSize: custSize,
                    };
                });
                setSpocAdded(custSize > 0);
                setSingleCustData(prev => ({
                    ...prev, choice: !spocAdded ? CustRelationChoice.SPOC : CustRelationChoice.RELATIVE,
                }))
                const tBaSize = Number(payload.totalBanquetBookingDetailsSize ?? 0);
                setTotalBanquetBookingDetails(prev => ({
                    ...prev,
                    added: tBaSize > 0,
                    items: payload.totalBanquetBookingDetails,
                    totalSize: tBaSize,
                }));
                setMainRoomId(tBaSize > 0 ? payload.totalBanquetBookingDetails[0].id ?? "" : "");
                const restaurantBillIdsSize = Number(payload.restaurantBillIdsSize ?? 0);
                setTotalBuffetDetails(prev => ({
                    ...prev,
                    added: restaurantBillIdsSize > 0,
                    items: payload.restaurantBillIds,
                    totalSize: restaurantBillIdsSize,
                }));
                const totalHotelRoomDetailsSize = Number(payload.totalHotelRoomDetailsSize ?? 0);
                setTotalHotelRoomDetails(prev => ({
                    ...prev,
                    added: totalHotelRoomDetailsSize > 0,
                    items: payload.totalHotelRoomDetails,
                    totalSize: totalHotelRoomDetailsSize,
                }));
                const restoredMap = deepConvertObjToMap(payload.extrasOrderMap);
                setExtraOrderMap(restoredMap);

                setKeyMapInformation(convertObjToMap(payload.keyMapInformation))
            }
        })
    };

    const fetchBillPayData = async (billId) => {
        await fetchBanquetBillPayInformation({
            authUser: authUser,
            activeShopHash: activeShopHash,
            mBillid: billId,
            setSnpLoader: setSnpLoader,
            onResponseCallback: (payload) => {
                printDebugLog("fetchBillPayData", payload);
                setBillPayInfo(prev => ({
                    ...prev, ...payload,
                }));
                fetchBillPayAuditData(billId);
                globalNetworkLock.current = false;
            }
        })
    };

    const fetchBillPayAuditData = async (billId) => {
        await fetchBanquetBillPayAuditInformation({
            authUser: authUser,
            activeShopHash: activeShopHash,
            mBillid: billId,
            onResponseCallback: (payload) => {
                setBillPayAudit(prev => ({
                    ...prev, ...payload,
                }))
            }
        })
    };

    const fetchOtherBanquetInfo = async () => {
        await fetchBanquetForBill({
            authUser: authUser,
            activeShopHash: activeShopHash,
            start: billInformation?.checkInDate,
            end: billInformation?.checkOutDate,
            onResponseCallback: (payload, error) => {
                if (error) {
                    console.error("fetchOtherBanquetInfo Error: ", error);
                } else {
                    const serverListBanquet = payload.details || [];
                    setListBanquetHall(serverListBanquet);
                    if (serverListBanquet.length > 0) {
                        validateIfHostAvailable(serverListBanquet);
                    } else {
                        setSnpComponent(prev => ({
                            ...prev,
                            negativeReq: true,
                            negativeAction: "Home",
                            positiveAction: "Change DateTime",
                            positiveReq: true,
                            showDialog: true,
                            outSideClickDismiss: true,
                            cancelExtra: true,
                            subTitle: "Do you want to change Date & Time or Go home",
                            handleSnpCancel: () => navigate("/home"),
                            handleSnpSubmit: () => clearAllDetails(),
                        }));
                    }
                }
            }
        })
    };


    const validateIfHostAvailable = (serverListBanquet) => {
        const existHost = serverListBanquet.some(room => room.roomId === banquetInformation.roomId);
        if (!existHost) {
            printDebugLog("validateIfHostAvailable", "host is deleting")
            setBanquetInformation(serverListBanquet[0]);
        }
    }

    const fetchAllComboFoodList = async () => {
        await fetchComboFoodDetails({
            authUser: authUser,
            activeShopHash: activeShopHash,
            setSnpLoader: setSnpLoader,
            onResponseCallback: (payload, error) => {
                if (error) {
                    console.error("fetchAllComboFoodList Error: ", error);
                } else {
                    setComboList(payload.fullData || []);
                }
            }
        })
    };

    const getCustomerByMobile = async (mob, spocAdded) => {
        await fetchSingleCustomerData({
            authUser: authUser,
            activeShopHash: activeShopHash,
            setSnpLoader: setSnpLoader,
            myParam: mob,
            onLocalMsg: (msg) => {
                setSnpComponent(prev => ({
                    ...prev,
                    isLoader: false,
                    negativeReq: false,
                    positiveAction: "Dismiss",
                    positiveReq: true,
                    showDialog: true,
                    outSideClickDismiss: false,
                    cancelExtra: true,
                    subTitle: msg,
                    handleSnpSubmit: () => setSnpComponent(INITIAL_SNP_COMPONENT),
                }));
            },
            onResponseCallback: (payload, error) => {
                if (error) {
                    setSingleCustData((s) =>
                        normalizeCustomer({ ...s, mobNo: mob }, { spocAdded, keepMob: mob })
                    );
                    setSnpComponent(prev => ({
                        ...prev, snackBarMsg: "Customer not found with " + mob, snackBarOpen: true,
                    }))
                } else {
                    setSingleCustData((s) =>
                        normalizeCustomer({ ...s, ...payload }, { spocAdded, keepMob: mob })
                    );
                }
            }
        })
    };

    const custDelSnippet = (mobNo) => {
        const updatedItems = customerInformation.items.filter(
            (singleValue) => singleValue.mobNo !== mobNo
        );

        setCustomerInformation(prev => ({
            ...prev,
            added: updatedItems.length > 0,
            totalSize: updatedItems.length,
            items: updatedItems,
        }));

        const kSpocAdded = updatedItems.length > 0;
        setSpocAdded(kSpocAdded);
        setSingleCustData({
            ...SINGLE_CUST_FORM,
            choice: kSpocAdded ? CustRelationChoice.RELATIVE : CustRelationChoice.SPOC,
        });
    };

    const deletCustomerData = async (billId, customerData) => {
        await deleteCustomerFromBill({
            custData: customerData,
            billId: billId,
            setSnpLoader: setSnpLoader,
            onResponseCallback: (errCode) => {
                if (errCode === SUCCESS || errCode === NODATA) {
                    custDelSnippet(customerData.mobNo);
                } else {
                    printDebugLog("deletCustomerData ", errCode);
                }
            }
        })
    }

    const deepConvertMapToObj = (map) => {
        const obj = {};
        for (const [key, value] of map.entries()) {
            obj[key] = value instanceof Map ? deepConvertMapToObj(value) : value;
        }
        return obj;
    };

    const bookingGenerateOperation = async (mState, partialPayObject, detailedBill = false) => {
        if (!customerInformation?.added ?? false) {
            setSnpComponent(prev => ({
                ...prev,
                negativeReq: true,
                negativeAction: "Ok!",
                positiveReq: false,
                showDialog: true,
                outSideClickDismiss: true,
                cancelExtra: true,
                subTitle: `Please add Customer Information`,
                handleSnpCancel: () => setSnpComponent(INITIAL_SNP_COMPONENT),
            }));
            return;
        }
        if (!totalBanquetBookingDetails?.added ?? false) {
            setSnpComponent(prev => ({
                ...prev,
                negativeReq: true,
                negativeAction: "Ok!",
                positiveReq: false,
                showDialog: true,
                outSideClickDismiss: true,
                cancelExtra: true,
                subTitle: `Please add Banquet details`,
                handleSnpCancel: () => setSnpComponent(INITIAL_SNP_COMPONENT),
            }));
            return;
        }
        //if (billData.billStatus !== BillStatus.ROOMALLOTEDNOTPAID && cancelBill && mState === UiButtonAction.CANCEL_BILL) {
        if (mState === UiButtonAction.PAY) {
            if (partialPayObject.partialAmt > 0.0) {
                if (partialPayObject.payMedium === PayMedium.NOT_SELECTED) {
                    setSnpComponent(prev => ({
                        ...prev,
                        snackBarOpen: true,
                        snackBarMsg: "Please select Payment methods",
                    }))
                    return;
                }
            }
        }
        if (mState === UiButtonAction.PAY_WITH_LINK) {
            if (partialPayObject.partialAmt === 0.0) {
                setSnpComponent(prev => ({
                    ...prev,
                    snackBarOpen: true,
                    snackBarMsg: "Please enter amount to pay",
                }))
                return;
            }
        }
        if ((billInformation?.billStatus ?? BillStatus.INUI) > BillStatus.ROOMALLOTEDNOTPAID
            && mState === UiButtonAction.CANCEL_BILL) {
            if (partialPayObject.partialAmt > 0.0) {
                if (partialPayObject.payMedium === PayMedium.NOT_SELECTED) {
                    setSnpComponent(prev => ({
                        ...prev,
                        snackBarOpen: true,
                        snackBarMsg: "Please select Payment methods",
                    }))
                    return;
                }
            }
        }
        await handleSubmitBill({
            authUser: authUser,
            activeShopHash: activeShopHash,
            setSnpLoader: setSnpLoader,
            billingModel: {
                ...billInformation,
                ...billPayInfo,
                extrasOrderMap: deepConvertMapToObj(extrasOrderMap),
                keyMapInfo: Object.fromEntries(keyMapInformation),
                totalBanquetBookingDetails: totalBanquetBookingDetails?.items || [],
                totalHotelRoomDetails: totalHotelRoomDetails?.items || [],
                totalBuffetDetails: totalBuffetDetails?.items || [],
                listCustomerDetails: customerInformation?.items || [],
                partialBillAudit: (mState === UiButtonAction.PAY || mState === UiButtonAction.PAY_WITH_LINK
                    || mState === UiButtonAction.CANCEL_BILL
                ) ? partialPayObject : null,
                state: mState,
                detailedBill: detailedBill,
            },
            onResponseCallback: (payload, error) => {
                if (error) {
                    console.error("bookingNetworkOperation Error: ", error);
                } else {
                    setBillInformation(prev => ({
                        ...prev,
                        ...payload.bookingDetails,
                    }));
                    let msg;
                    if (mState === UiButtonAction.PAY) {
                        msg = `Successfully paid installment for Booking Id: ${payload.bookingDetails.bookingId}`;
                    } else if (mState === UiButtonAction.SAVE_BILL) {
                        msg = `Successfully saved the details for Booking Id: ${payload.bookingDetails.bookingId}`;
                    } else if (mState === UiButtonAction.PRINT) {
                        msg = `Print generated for Booking Id: ${payload.bookingDetails.bookingId}`;
                    } else if (mState === UiButtonAction.SETTLE) {
                        msg = `Successfully settled the bill for Booking Id: ${payload.bookingDetails.bookingId}`;
                    } else if (mState === UiButtonAction.PAY_WITH_LINK) {
                        msg = `Successfully initiated installment for Booking Id: ${payload.bookingDetails.bookingId}`;
                    } else if (mState === UiButtonAction.CANCEL_BILL) {
                        msg = `Successfully cancel the Booking Id: ${payload.bookingDetails.bookingId}`;
                    } else if (mState === UiButtonAction.GENERATE_ESTIMATION) {
                        msg = `Booking Id: ${payload.bookingDetails.bookingId} generated successfully`;
                    }
                    setSnpComponent(prev => ({
                        ...prev,
                        isLoader: false,
                        negativeReq: true,
                        negativeAction: "Home",
                        positiveAction: "Print",
                        positiveReq: true,
                        showDialog: true,
                        outSideClickDismiss: false,
                        cancelExtra: true,
                        subTitle: msg,
                        handleSnpSubmit: () => {
                            const url = BASE_URL + "/files/" + payload.path;
                            window.open(url, '_blank');
                            setSnpComponent(INITIAL_SNP_COMPONENT);
                            if (mState === UiButtonAction.PAY
                                || mState === UiButtonAction.PAY_WITH_LINK
                                || mState === UiButtonAction.CANCEL_BILL) {
                                fetchBillPayData(payload.bookingDetails.id);
                                fetchBillPayAuditData(payload.bookingDetails.id);
                            }
                        },
                        handleSnpCancel: () => navigate("/home"),
                    }));
                }
            }
        })
    };

    const handlePermanentDelete = async () => {
        await handleDeleteEntireBill({
            setSnpLoader: setSnpLoader,
            activeShopHash: activeShopHash,
            id: billInformation?.id ?? "",
            setSnpComponent: setSnpComponent,
            navigate: navigate,
        })
    };

    const handlePermanentDeleteUnpaidBill = async (id) => {
        await handleDeleteUnpaidDetails({
            authUser: authUser,
            setSnpLoader: setSnpLoader,
            activeShopHash: activeShopHash,
            id: id,
            setSnpComponent: setSnpComponent,
            navigate: navigate,
            handleSuccess: () => fetchBillPayAuditData(billInformation.id),
        })
    };

    const renderSnpContent = () => {
        return (
            <Grid container spacing={1}
                display="flex"
                alignItems="center" sx={{
                    padding: 2,
                }}>
                <Grid item xs={12}>
                    <Paper
                        elevation={4}
                        sx={{
                            borderRadius: 2,
                            p: 2,
                            backgroundColor: "#f5f5dc",
                        }}>

                        <Grid container spacing={2}>
                            {
                                !isEmpty(billInformation?.bookingId) &&
                                <Grid item xs={12} md={4}>
                                    {
                                        (isInvoiceAllowed && !isEmpty(billInformation?.invoiceId ?? "")) ?
                                            <p style={{
                                                fontWeight: "bold",
                                                color: "#3b6463",
                                                whiteSpace: 'pre-wrap', overflowWrap: 'break-word',
                                                fontSize: '18px', justifyContent: 'center', alignItems: 'center', alignContent: 'center',
                                                padding: '1px', fontFamily: "monospace"
                                            }}>{`BookingId# ${billInformation?.bookingId ?? ""}/Invoice ${prefixBillName}${billInformation?.invoiceId ?? ""}`}</p> :
                                            <p style={{
                                                fontWeight: "bold",
                                                color: "#3b6463",
                                                whiteSpace: 'pre-wrap', overflowWrap: 'break-word',
                                                fontSize: '18px', justifyContent: 'center', alignItems: 'center', alignContent: 'center',
                                                padding: '1px', fontFamily: "monospace"
                                            }}>{`BookingId# ${billInformation?.bookingId ?? ""} ${(billInformation?.billStatus ?? BillStatus.INUI) === BillStatus.MODE_ESTIMATION
                                                ? "(In Estimation)" : ""}`}</p>
                                    }
                                </Grid>
                            }
                            {
                                !isEmpty(billInformation?.checkInDate) &&
                                <Grid item xs={12} md={4}>
                                    <p style={{
                                        fontWeight: "bold",
                                        color: "#798533",
                                        whiteSpace: 'pre-wrap', overflowWrap: 'break-word',
                                        fontSize: '16px', justifyContent: 'center', alignItems: 'center', alignContent: 'center',
                                        padding: '1px', fontFamily: "monospace"
                                    }}>{`CheckIn: ${billInformation?.checkInDate ?? ""}`}</p>
                                </Grid>
                            }
                            {
                                !isEmpty(billInformation?.checkOutDate) &&
                                <Grid item xs={12} md={4}>
                                    <p style={{
                                        fontWeight: "bold",
                                        color: "#5c482d",
                                        whiteSpace: 'pre-wrap', overflowWrap: 'break-word',
                                        fontSize: '16px', justifyContent: 'center', alignItems: 'center', alignContent: 'center',
                                        padding: '1px', fontFamily: "monospace"
                                    }}>{`CheckOut: ${billInformation?.checkOutDate ?? ""}`}</p>
                                </Grid>
                            }

                            {
                                (configBanquetShift && configBanquetShift?.length > 0) &&
                                <Grid item xs={12} md={6} sm={6} lg={6}>
                                    <Autocomplete
                                        id="shift-select"
                                        options={configBanquetShift}
                                        autoHighlight
                                        variant="filled"
                                        size="small"
                                        disabled={(billInformation?.billStatus ?? BillStatus.INUI) === BillStatus.CANCELLED_BILL}
                                        fullWidth
                                        onChange={(e, option) => {
                                            if (option) {
                                                setKeyMapInformation(prev => {
                                                    const newMap = new Map(prev);
                                                    newMap.set(BANQUET_SHIFT, option);
                                                    return newMap;
                                                });
                                            } else {
                                                setKeyMapInformation(prev => {
                                                    const newMap = new Map(prev);
                                                    newMap.delete(BANQUET_SHIFT);
                                                    return newMap;
                                                });
                                            }
                                        }}
                                        isOptionEqualToValue={(option, value) => option === value}
                                        getOptionLabel={(option) => option ?? ""}
                                        value={keyMapInformation.get(BANQUET_SHIFT) ?? ""}
                                        renderOption={(props, option) => {
                                            return (
                                                <Box
                                                    component="li"
                                                    {...props}
                                                >
                                                    {option}
                                                </Box>
                                            );
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Select Shift Type"
                                                inputProps={{
                                                    ...params.inputProps,
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                            }
                            {
                                (configBanquetFunction && configBanquetFunction?.length > 0) && <Grid item xs={12} md={6} sm={6} lg={6}>
                                    <Autocomplete
                                        id="banquet-select"
                                        options={configBanquetFunction}
                                        autoHighlight
                                        variant="filled"
                                        size="small"
                                        fullWidth
                                        disabled={(billInformation?.billStatus ?? BillStatus.INUI) === BillStatus.CANCELLED_BILL}
                                        onChange={(e, option) => {
                                            if (option) {
                                                setKeyMapInformation(prev => {
                                                    const newMap = new Map(prev);
                                                    newMap.set(BANQUET_FUNCTION, option);
                                                    return newMap;
                                                });
                                            } else {
                                                setKeyMapInformation(prev => {
                                                    const newMap = new Map(prev);
                                                    newMap.delete(BANQUET_FUNCTION);
                                                    return newMap;
                                                });
                                            }
                                        }}
                                        isOptionEqualToValue={(option, value) => option === value}
                                        getOptionLabel={(option) => option ?? ""}
                                        value={keyMapInformation.get(BANQUET_FUNCTION) ?? ""}
                                        renderOption={(props, option) => {
                                            return (
                                                <Box
                                                    component="li"
                                                    {...props}
                                                >
                                                    {option}
                                                </Box>
                                            );
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Select Function Type"
                                                inputProps={{
                                                    ...params.inputProps,
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                            }
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={12}>
                    <Stack direction="row" spacing={0.5} flexWrap="wrap" sx={{ mb: 2 }}>
                        {BANQUET_BILL_CATEGORIES.map((cat) => (
                            <Chip
                                key={cat.id}
                                label={cat.name}
                                color={cat.id === selectedCategory?.id ? "primary" : "default"}
                                onClick={() => setSelectedCategory(cat)}
                                clickable
                                sx={{
                                    fontSize: "1rem",
                                    height: 40,
                                    "& .MuiChip-label": {
                                        px: 1,
                                    },
                                }}
                            />
                        ))}
                    </Stack>
                </Grid>
                {
                    selectedCategory?.id === DATE_SELECTION &&
                    <Grid item xs={12}>
                        <BookingCalendar
                            authUser={authUser}
                            activeShopHash={activeShopHash}
                            bookingCount={sameDateBookingCount}
                            readOnlyPast={true}
                            previousDateBooking={bookings}
                            disabledDate={() => false}
                            setSnpLoader={setSnpLoader}
                            setSnpComponent={setSnpComponent}
                            clearSnpComponent={() => setSnpComponent(INITIAL_SNP_COMPONENT)}
                            billInformation={billInformation}
                            roomId={mainRoomId}
                            setBillingData={setBillInformation}
                            clearAllDetails={clearAllDetails}
                            nextCateogory={() => setSelectedCategory(prev => ({ ...prev, id: CUSTOMER, name: "Customer Form" }))}
                            fetchBooking={(billId) => handleFetchBooking(billId)}
                            paymentInitiated={billPayInfo?.paymentInitiated ?? false}
                        />
                    </Grid>
                }
                {
                    selectedCategory?.id === BANQUET &&
                    <BanquetForm
                        listBanquetHall={listBanquetHall}
                        stayType={billInformation?.stayType ?? -1}
                        totalDaysStay={billInformation?.totalDaysStay ?? 0}
                        totalBanquetBookingDetails={totalBanquetBookingDetails}
                        setTotalBanquetBookingDetails={setTotalBanquetBookingDetails}
                        billPayInfo={billPayInfo}
                        setBillPayInfo={setBillPayInfo}
                        disabledOperation={(billInformation?.billStatus ?? BillStatus.INUI) === BillStatus.CANCELLED_BILL}
                        setSnpComponent={setSnpComponent}
                        initialBanquetInformation={banquetInformation} />
                }
                {
                    selectedCategory?.id === ROOM_SELECTION
                    && <RoomForm
                        stayType={billInformation?.stayType ?? -1}
                        totalDaysStay={billInformation?.totalDaysStay ?? 0}
                        roomData={roomData}
                        totalHotelRoomDetails={totalHotelRoomDetails}
                        setTotalHotelRoomDetails={setTotalHotelRoomDetails}
                        billPayInfo={billPayInfo}
                        setBillPayInfo={setBillPayInfo}
                        disabledOperation={(billInformation?.billStatus ?? BillStatus.INUI) === BillStatus.CANCELLED_BILL}
                        setSnpComponent={setSnpComponent}
                    />
                }
                {
                    selectedCategory?.id === CUSTOMER &&
                    <CustomerDetailsForm
                        billId={billInformation?.id ?? ""}
                        spocAdded={spocAdded}
                        setSpocAdded={setSpocAdded}
                        customerInformation={customerInformation}
                        setCustomerInformation={setCustomerInformation}
                        singleCustData={singleCustData}
                        setSingleCustData={setSingleCustData}
                        handleGetCustomerByMobile={(mob, spocAdded) => {
                            setSingleCustData(prev => ({
                                ...prev, mobNo: mob,
                            }))
                            getCustomerByMobile(mob, spocAdded);
                        }}
                        setSnpComponent={setSnpComponent}
                        bookingId={billInformation?.id ?? ""}
                        paymentInitiated={billPayInfo?.paymentInitiated ?? false}
                        deletCustomerData={(billId, custData) => deletCustomerData(billId, custData)}
                        custDelSnippet={custDelSnippet}
                        keyMapInformation={keyMapInformation}
                        setKeyMapInformation={setKeyMapInformation}
                        apiToken={authUser.apiToken}
                        shopHash={activeShopHash.id}
                        disabledOperation={(billInformation?.billStatus ?? BillStatus.INUI) === BillStatus.CANCELLED_BILL
                            || (billPayInfo?.paymentInitiated ?? false)
                        }
                    />
                }
                {
                    selectedCategory?.id === BUFFET &&
                    <BuffetForm
                        stayType={billInformation?.stayType ?? -1}
                        totalDaysStay={billInformation?.totalDaysStay ?? 0}
                        totalBuffetDetails={totalBuffetDetails}
                        setTotalBuffetDetails={setTotalBuffetDetails}
                        comboList={comboList}
                        fetchAllComboFoodList={fetchAllComboFoodList}
                        setSnpComponent={setSnpComponent}
                        configBuffetType={configBuffetType}
                        billPayInfo={billPayInfo}
                        keyMapInformation={keyMapInformation}
                        setBillPayInfo={setBillPayInfo}
                        disabledOperation={(billInformation?.billStatus ?? BillStatus.INUI) === BillStatus.CANCELLED_BILL}
                    />
                }
                {
                    selectedCategory?.id === EXTRA_DETAILS &&
                    <ExtraBanquetForm
                        totalDaysStay={billInformation?.totalDaysStay ?? 0}
                        billInformation={billInformation}
                        configDecoration={configDecoration}
                        configDj={configDj}
                        extrasOrderMap={extrasOrderMap}
                        setExtraOrderMap={setExtraOrderMap}
                        billPayInfo={billPayInfo}
                        setBillPayInfo={setBillPayInfo}
                        setSnpComponent={setSnpComponent}
                        setBillInformation={setBillInformation}
                        keyMapInformation={keyMapInformation}
                        disabledOperation={(billInformation?.billStatus ?? BillStatus.INUI) === BillStatus.CANCELLED_BILL}
                        setKeyMapInformation={setKeyMapInformation}
                    />
                }
                {
                    (!isEmpty(billInformation?.checkInDate)
                        && !isEmpty(billInformation?.checkOutDate)) &&
                    <Grid item xs={12}>
                        <p style={{
                            whiteSpace: 'pre-wrap', overflowWrap: 'break-word',
                            fontFamily: "monospace", fontWeight: "bolder",
                            fontSize: '24px', justifyContent: 'center', alignItems: 'center', alignContent: 'center',
                            padding: '2px'
                        }}>Payment Information</p>
                    </Grid>
                }
                {
                    (!isEmpty(billInformation?.checkInDate)
                        && !isEmpty(billInformation?.checkOutDate)) && <Grid item xs={12}>
                        <PaymentScreen
                            billInformation={billInformation}
                            billPayInfo={billPayInfo}
                            billPayAudit={billPayAudit}
                            isRoleAllowed={isRoleAllowed}
                            setBillPayInfo={setBillPayInfo}
                            setBillPayAudit={setBillPayAudit}
                            setSnpComponent={setSnpComponent}
                            onlinePayMethod={authUser?.onlinePayMethod ?? []}
                            bookingGenerateOperation={bookingGenerateOperation}
                            handleDeleteEntireBill={handlePermanentDelete}
                            handlePermanentDeleteUnpaidBill={handlePermanentDeleteUnpaidBill}
                            keyMapInformation={keyMapInformation}
                            totalDuesAmt={duesAmt}
                            cancelBillFeature={isFeatureAllowed(authUser.packages, CANCEL_BILL_MANAGEMENT)}
                            epayAllowed={isFeatureAllowed(authUser.packages, EPAYBILLING)}
                            setKeyMapInformation={setKeyMapInformation}
                        />
                    </Grid>
                }

            </Grid >
        )
    }


    return (
        <SnpComponent showDialog={snpComponent.showDialog}
            title={snpComponent.title}
            isLoader={snpLoader}
            subTitle={snpComponent.subTitle}
            negativeAction={snpComponent.negativeAction}
            positiveReq={snpComponent.positiveReq}
            positiveAction={snpComponent.positiveAction}
            negativeReq={snpComponent.negativeReq}
            iconReq={snpComponent.iconReq}
            iconContent={snpComponent.iconContent}
            content={renderSnpContent()}
            onSnackClose={() => setSnpComponent(prev => ({
                ...prev,
                snackBarOpen: false,
                snackBarMsg: "",
            }))}
            handleSubmit={snpComponent.handleSnpSubmit}
            onCancel={snpComponent.handleSnpCancel}
            cancelExtra={snpComponent.cancelExtra}
            snackBarOpen={snpComponent.snackBarOpen}
            snackBarMsg={snpComponent.snackBarMsg}
            outSideClickDismiss={snpComponent.outSideClickDismiss}
        />
    );
};

export { CreateBanquetBill };